const maskedHabitatRoutes = ['help', 'inspiration', 'shop-by-room', 'stores', 'events']

const isHelpPath = (path) => {
  if (!path) return null
  const locationRegex = /\/(.*?)\//
  const getPageType = locationRegex.exec(path)
  return getPageType && getPageType[1] === 'help'
}

const isMaskedHabitatPath = (path) => {
  if (!path) return null
  return maskedHabitatRoutes.some((route) => path.startsWith(`/${route}`) || path.startsWith(`/features/${route}`))
}

const isHomepagePath = (path) => (path && path === '/') || false
const isHabitatHomepagePath = (path) => isHomepagePath(path) && process.env.BRAND === 'habitat'

const isReviewsPath = (path) => (path && path.startsWith('/reviews')) || false
const isReviewsArgosCard = (path) => (path && path.split('reviews/')[1] === 'argos-card') || false

const isCmsPath = (path) => {
  if (!path) return null
  if (isHabitatHomepagePath(path)) return true
  const locationRegex = /\/(.*?)\//
  const getPageType = locationRegex.exec(path)
  return getPageType && ['events', 'brands', 'features'].indexOf(getPageType[1]) !== -1
}
const isMagnoliaApp = (path) => isCmsPath(path) || isHelpPath(path) || isMaskedHabitatPath(path)

const getCleanPath = (path) =>
  path
    .substr(1)
    .split('?')[0]
    .replace(/\//g, '-')

const getRoute = (path) => {
  if (isHomepagePath(path)) return 'homepage'
  if (isCmsPath(path)) return 'cms'
  if (isHelpPath(path)) return 'help'
  if (isReviewsPath(path)) return 'reviews'
  return 'errorpage'
}

export {
  maskedHabitatRoutes,
  isCmsPath,
  isHomepagePath,
  isHabitatHomepagePath,
  isMaskedHabitatPath,
  isReviewsPath,
  isHelpPath,
  isMagnoliaApp,
  isReviewsArgosCard,
  getRoute,
  getCleanPath,
}
